export const assetLabel = (name: string, internalId?: string) =>
  `${name}${internalId ? ` (${internalId})` : ''}`;
